import clsx from 'clsx'

interface Props {
  label: string
  count: number
  active: boolean
  onClick: () => void
  emerald?: boolean
  danger?: boolean
}

export default function TabBtn({ label, count, active, onClick, emerald = false, danger = false }: Props) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors',
        active
          ? danger
            ? 'border-rose-500 text-rose-600'
            : emerald
              ? 'border-emerald-500 text-emerald-700'
              : 'border-brand-500 text-brand-600'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
      )}
    >
      {label}
      <span className={clsx(
        'inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-xs leading-none',
        active
          ? danger
            ? 'bg-rose-100 text-rose-600'
            : emerald
              ? 'bg-emerald-100 text-emerald-700'
              : 'bg-brand-100 text-brand-700'
          : 'bg-gray-100 text-gray-500',
      )}>
        {count}
      </span>
    </button>
  )
}
